/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_CommunitiesInputs */

const en_your_communities = /** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Communities`)
};

const es_your_communities = /** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus Comunidades`)
};

const fr_your_communities = /** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos communautés`)
};

const de_your_communities = /** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Communities`)
};

const id_your_communities = /** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas Anda`)
};

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const ja_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const zh_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const ar_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const it_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const ru_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const pt_your_communities = en_your_communities;

/** @type {(inputs: Your_CommunitiesInputs) => LocalizedString} */
const ko_your_communities = en_your_communities;

/**
* | output |
* | --- |
* | "Your Communities" |
*
* @param {Your_CommunitiesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_communities = /** @type {((inputs?: Your_CommunitiesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_CommunitiesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_communities(inputs)
	if (locale === "es") return es_your_communities(inputs)
	if (locale === "fr") return fr_your_communities(inputs)
	if (locale === "de") return de_your_communities(inputs)
	if (locale === "ja") return ja_your_communities(inputs)
	if (locale === "zh") return zh_your_communities(inputs)
	if (locale === "ar") return ar_your_communities(inputs)
	if (locale === "id") return id_your_communities(inputs)
	if (locale === "it") return it_your_communities(inputs)
	if (locale === "ru") return ru_your_communities(inputs)
	if (locale === "pt") return pt_your_communities(inputs)
	return ko_your_communities(inputs)
});